import React, { useContext } from "react";
import { FooterHelp, Button, Text, Link } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { PublicContext } from "lib/context";
import { baseHelper, storageHelper } from "lib/helpers";
import config from "configuration";

const Footer = (props) => {
  const { cms } = useContext(PublicContext);
  const navigate = useNavigate();
  const { loginVia = "email" } = props || {};
  const url = baseHelper.parseUrl(config.rootURL);
  const isCustomDomain = window.location.hostname !== url.hostname;
  const { pathname = "" } = window.location;
  const footerContent = cms("footer").map((item) => {
    if (item && item.link) {
      // const redirectUri = isCustomDomain ? "/register" : item.link;
      const redirectUri = isCustomDomain ? "/register" : "/register/seller";
      return (
        <>
          {" "}
          <Button
            key={item.content}
            variant="plain"
            id="registerHere"
            onClick={() => {
              navigate({
                pathname: redirectUri,
                state: { loginVia },
              });
            }}
          >
            {item.content}
          </Button>
        </>
      );
    }
    return (
      <React.Fragment key={item.content}>
        {isCustomDomain || storageHelper.get("hideMcDetails") ? "New Vendor? " : item.content}
      </React.Fragment>
    );
  });
  return (
    <>
      {pathname !== "/prelogin" && <FooterHelp>{footerContent}</FooterHelp>}
      {!storageHelper.get("hidePoweredBy") && pathname !== "/prelogin" ? (
        <center>
          <Text variant="bodySm" as="p">
            <Text as="span" tone="subdued">
              {`${cms("common.label.poweredBy")}${" "}`}
              {!(isCustomDomain || storageHelper.get("hideMcDetails")) ? (
                <Link url="https://www.marketcube.io" target="_blank">
                  {cms("common.label.marketcube")}
                </Link>
              ) : (
                `${cms("common.label.marketcube")}`
              )}
            </Text>
          </Text>
        </center>
      ) : (
        !storageHelper.get("hidePoweredBy") && (
          <center style={{ marginTop: "90px", marginLeft: "40px" }}>
            <Text variant="bodySm" as="p">
              <Text as="span" tone="subdued">
                {`${cms("common.label.poweredBy")}${" "}`}
                {!(isCustomDomain || storageHelper.get("hideMcDetails")) ? (
                  <Link url="https://www.marketcube.io" target="_blank">
                    {cms("common.label.marketcube")}
                  </Link>
                ) : (
                  `${cms("common.label.marketcube")}`
                )}
              </Text>
            </Text>
          </center>
        )
      )}
    </>
  );
};

export default Footer;
